import Image from "next/image";
import { FunctionComponent } from "react";

import styles from "./SymbolIcon.module.scss";

import { eSymbol, selectImgSymbols } from "@lib/helper/symbolUtils";

export interface ISymbolIconProps {
  symbol: eSymbol;
  percentage?: number;
  className?: string;
}

const SymbolIcon: FunctionComponent<ISymbolIconProps> = ({ symbol, percentage, className }) => {
  const imageSymbol = selectImgSymbols(symbol, percentage);
  return (
    <div className={`${styles["symbol-icon"]} ${className}`}>
      <Image
        src={imageSymbol}
        alt="symbol icon"
        width={48}
        height={48}
        sizes="7vw"
        style={{
          width: "100%",
          height: "auto",
        }}
      />
    </div>
  );
};

export default SymbolIcon;
